import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

/**
 * Earning Schema
 * Represents administrative earnings in the system
 * Base schema is loose to allow loading legacy data.
 */
export const EarningSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    monthYear: Yup.date().nullable(),
    totalOrders: Yup.number().nullable(),
    totalSales: Yup.number().nullable(),
    totalCommission: Yup.number().nullable(),
    totalBonus: Yup.number().nullable(),
    totalEarnings: Yup.number().nullable(),
    status: Yup.string().oneOf(["Pending", "Paid", "Cancelled"]).nullable(),
  });

/**
 * Earning Validation Schema
 * Strict rules applied only during form submission.
 */
export const EarningValidationSchema = EarningSchema.clone().shape({
  monthYear: Yup.date().required(),
  totalOrders: Yup.number().required().min(0),
  totalSales: Yup.number().required().min(0),
  totalCommission: Yup.number().required().min(0),
  totalBonus: Yup.number().required().min(0),
  totalEarnings: Yup.number().required().min(0),
  status: Yup.string().oneOf(["Pending", "Paid", "Cancelled"]).required(),
});
